<template>
  <div class="relative inline-block border rounded-full border-neutral-400 hover:bg-gray-100">
    <button
      type="button"
      @click="toggle"
      class="flex items-center gap-2 px-4 py-2 text-sm text-neutral-400 rounded-full"
    >
      <component :is="icon" v-if="icon" class="w-4 h-4" />
      <span>{{ label }}</span>
      <span
        v-if="hasActiveFilter"
        class="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-primary30 text-white"
      >
        1
      </span>
    </button>

    <div
      v-if="isOpen"
      @click.stop
      class="absolute z-10 mt-2 left-0 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 min-w-[260px] border border-neutral-200 p-4"
    >
      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-500 font-medium">Valor mínimo (R$)</label>
          <input
            v-model="localMin"
            type="number"
            min="0"
            step="0.01"
            placeholder="0,00"
            class="w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
          />
        </div>
        <div class="flex flex-col gap-1">
          <label class="text-xs text-gray-500 font-medium">Valor máximo (R$)</label>
          <input
            v-model="localMax"
            type="number"
            min="0"
            step="0.01"
            placeholder="0,00"
            class="w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
          />
        </div>
        <button
          type="button"
          class="w-full py-1.5 text-sm font-medium text-white bg-primary30 rounded hover:opacity-90"
          @click="applyFilter"
        >
          Aplicar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, type Component } from 'vue'

export interface ValueRange {
  min: number | undefined
  max: number | undefined
}

defineProps<{
  label?: string
  icon?: Component
  isOpen?: boolean
}>()

const emit = defineEmits<{
  (e: 'select', payload: ValueRange): void
}>()

const localMin = ref<number | undefined>(undefined)
const localMax = ref<number | undefined>(undefined)

const hasActiveFilter = computed(() => localMin.value !== undefined || localMax.value !== undefined)

function toggle() {
  // handled by parent via isOpen prop
}

function applyFilter() {
  emit('select', {
    min:
      localMin.value !== undefined && localMin.value !== null ? Number(localMin.value) : undefined,
    max:
      localMax.value !== undefined && localMax.value !== null ? Number(localMax.value) : undefined
  })
}

function reset() {
  localMin.value = undefined
  localMax.value = undefined
}

defineExpose({ reset })
</script>
